import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { ConfigService } from 'src/app/core/service/config.service';
import * as moment from 'moment';
import { MatDialog } from '@angular/material/dialog';
import { TimerService } from 'src/app/shared/services/Timer.service';
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { Gallery, ImageItem, ImageSize, ThumbnailsPosition } from 'ng-gallery';
import { Lightbox } from 'ng-gallery/lightbox';
import { ApiAuctionsService } from 'src/app/features/bidders/core/service/api-auctions.service';
import { SliderModal } from 'src/app/features/bidders/core/modal/slider';
import { AuctionModal } from 'src/app/features/bidders/core/modal/auctions';
import { BtnsModal } from 'src/app/features/bidders/core/modal/btns';
import { DetailsItemModal } from 'src/app/features/bidders/core/modal/details-item';
import { SocketService } from 'src/app/features/bidders/core/service/socket.service';
import { JoinAuctionComponent } from 'src/app/features/bidders/component/auction/joinAuction/joinAuction.component';
import { WithdrawComponent } from 'src/app/features/bidders/component/auction/withdraw/withdraw.component';
import { NotEnoughFundComponent } from 'src/app/features/bidders/component/auction/not-enough-fund/not-enough-fund.component';

import { interval, Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { AuctionWinnerPopUpComponent } from '../auction-winner-pop-up/auction-winner-pop-up.component';
import { AuctionEndedPopUpComponent } from '../auction-ended-pop-up/auction-ended-pop-up.component';
import { SocketEventType } from 'src/app/features/bidders/core/modal/socket-event-type';
import { SocketUpates } from 'src/app/features/rooms/core/modal/socketUpdates';
import { socketActions } from 'src/app/features/rooms/core/enums/socketActions';
import { HardRedirectComponent } from '../../hard-redirect/hard-redirect.component';
import { SharedService } from 'src/app/shared/services/shared.service';
import { OfflineComponent } from '../../offline/offline.component';

@Component({
  selector: 'app-auction-details',
  templateUrl: './auction-details.component.html'
})
export class AuctionDetailsComponent implements OnInit {
  @Output() LessThan10Second = new EventEmitter<number>();
  @Input() isbidder = false;
  externalContentUrl!: string;
  remaining = true;
  intervalRemaining: any;
  customOptions: OwlOptions = {
    rtl: localStorage.getItem("language") == "ar" ? true : false,
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: false,
    dots: true,
    center: true,
    navSpeed: 700,
    navText: ['', ''],
    margin: 25,
    responsive: {
      0: {
        items: 1
      },
      400: {
        items: 4
      },
      740: {
        items: 4
      },
      940: {
        items: 4
      },
      1200: {
        items: 6
      }
    },
    nav: false
  }
  auctionStatus = 'end';
  auctionId: any | undefined;

  auctionData: AuctionModal | any;
  btns: BtnsModal[] | undefined;
  loading = true;
  number: number | any;
  detailsItem!: DetailsItemModal[];
  slider: SliderModal[] = [];
  bidders: any = [];
  userInfo: any;
  biddingPrice: any;
  lastbid: any;
  minus = false;
  CustomPrice = 0;

  SECONDS: any;
  minutes: any;
  current_balance: any;
  actual_current_balance: any;
  winnerAuction = false;
  endDateTimer: any;
  startDateTimer: any;
  winnerUserAuction: any = 0;

  // Media List
  MediaList: any;
  admin = false;
  getBidders = true;
  showCounter = false;
  LastBidder: any;

  auctioneer = false;
  master = false;
  lastSeconds!: number;
  timeExtended: boolean = false;

  // 30 Seconds countdown timer
  TotalCounts: number = 60;
  currentCount: number = 30;


  private countDownDate!: number;
  public secondsDown: number = 90;
  timesetInterval!: any;
  currentPercent = 100;

  subscription!: Subscription;
  duration: any = 90;
  timeLeft = this.duration;
  percent = 100;
  second = 90;
  msgToastr: any;
  showIncreasePrice: boolean = false;


  subscriptions: Subscription[] = []
  OnlineStatus: boolean = true;

  constructor(
    private _activatedRouter: ActivatedRoute,
    public _auctionApi: ApiAuctionsService,
    public _config: ConfigService,
    public socket: SocketService,
    private dialog: MatDialog,
    private _timer: TimerService,
    private sanitizer: DomSanitizer,
    public gallery: Gallery, public lightbox: Lightbox,
    private router: Router,
    public translate: TranslateService,
    private _SharedService: SharedService

  ) {



    const roleCode = _config.getAuthUserInfo()?.user?.role_code;
    this.admin = (roleCode == 'Admin') ? true : false;
    this.auctioneer = (roleCode == 'Auctioneer') ? true : false;
    this.master = (roleCode == 'Master') ? true : false;



    this.userInfo = _config.getAuthUserInfo();

    // socket?.socket?.on('auth', (data: any) => {

    // })
    // socket?.socket?.on('auctionNotVaild', (data: any) => {
    //   window.location.reload();
    // })
    this.subscriptions.push(
      this.socket.getDataStream<string>(SocketEventType.Auth)
        .subscribe(message => {
          console.log("From Auth: " + SocketEventType.Auth);
        })
    )
    this.subscriptions.push(
      this.socket.getDataStream<string>(SocketEventType.Auction_Not_Valid)
        .subscribe(message => {
          window.location.reload();
          console.log("From Auction_Not_Valid: " + SocketEventType.Auction_Not_Valid);
        })
    )


    // socket?.socket?.on('UpdateBlance' + this._config.getAuthUserInfo().user.id, (data: any) => {
    //   this.getBalance();
    // })
    this.subscriptions.push(
      this.socket.getDataStream<string>(SocketEventType.Update_Blance)
        .subscribe(message => {
          this.getBalance();
          console.log("From Update_Blance: " + SocketEventType.Update_Blance);

        })
    )

    // socket?.socket?.on('getRemaining', (data: any) => {
    //   this.auctionData.remaining_time = data;
    //   console.log("getRemaining", this.auctionData.remaining_time);

    // })
    this.subscriptions.push(
      this.socket.getDataStream<string>(SocketEventType.Get_Remaining)
        .subscribe(message => {

          this.auctionData.remaining_time = message.data;
        })
    )



  }



  getRemaining() {

    // console.log(event);
    // this.auctionData.remaining_time = event;

    // if (this.auctionData?.is_reserve && !this.auctionData?.is_closed && this.auctionData?.remaining_time <= 300) {
    //   this.showIncreasePrice = true;
    // }
    // if (this.remaining && this.auctionData.remaining_time < 60 && this.auctionStatus == "ongoing") {
    //   this.remaining = false;
    //   this.socket?.socket?.emit("getRemaining", this.auctionId);

    // }

  }

  timerAuctionNoEndTime(duration: any, timeLeft: any, percent: any, second: any) {
    this.duration = duration;
    this.timeLeft = timeLeft;
    this.percent = percent;

    this.second = second;
    // if (this.second < 90 && this.second > 60) {
    //   this.timeLeft = this.second - 60;
    //   this.percent = (this.timeLeft / this.duration) * 100;

    // }
    // if (this.second < 60 && this.second > 30) {
    //   this.timeLeft = this.second - 30;
    //   this.percent = (this.timeLeft / this.duration) * 100;
    // }
    const interval$ = interval(1000);
    this.subscription = interval$.subscribe(() => {
      this.timeLeft--;
      this.second--;
      this.percent = (this.timeLeft / this.duration) * 100;
      if (this.timeLeft <= 0 && this.second <= 0) {


        this.OnReload('ongoing', true);
        this.unsubscribeTimerAuctionNoEndTime()
      }

      if (this.timeLeft === 0 && this.second > 0) {
        this.timeLeft = 30;
        this.percent = 100;
      }
    });

  }

  unsubscribeTimerAuctionNoEndTime() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  ngOnInit() {
    // alert(moment().diff(moment('2023-08-14T15:13:06.175Z'), 'seconds'))
    this.auctionId = this._activatedRouter.snapshot.params["id"];

    this.onGetAuction();
    this.priceNotVaild();
    this.getBalance();
    // this.onNewBidding();
    this.socket.socket.emit(`joinAuction`, this.auctionId);

    this.socket.ListenOnAuctionSocket(this.auctionId)

    this.subscriptions.push(
      this.socket.getDataStream<string>(this.auctionId)
        .subscribe(message => {
          // debugger
          if (message.data.id == this.auctionId) {
            // console.log("From Auction_ID: " + SocketEventType.Auction_ID);
            this.onNewBidding(message?.data?.response);
          }
        })
    )

    this.MediaConfig();
    this.notEnoughFund();

    // this.socket?.socket?.on(`reloadPage${this.auctionId}`, (data: any) => {
    //   // this.loading = true;
    //   // this.onGetAuction();
    //   console.log(`Reload Page is Called ===>${new Date().toLocaleDateString()}`);

    //   this.auctionData.is_closed = 1;
    //   if (this.auctionData.is_reserve && Number(this.bidders[0].price) < Number(this.auctionData.reserve_price)) {
    //     this.winnerAuction = true;
    //     this.getWinner();

    //     if (this.winnerAuction == true && this.userInfo.user.role_code == 'General' && this.bidders[0].userID == this.userInfo.user.id) {
    //       this.openCongratulationDialog()
    //     } else if (this.userInfo.user.role_code == 'General' && this.bidders[0].userID != this.userInfo.user.id) {
    //       this.winnerAuction = false;
    //       this.openItemEndedDialog()
    //     }


    //   }
    // })

    this.subscriptions.push(
      this.socket.getDataStream<string>(`reloadPage${this.auctionId}`)
        .subscribe(message => {
          // debugger
          if (message.data.id === this.auctionId) {
            // this.loading = true;
            // this.onGetAuction();
            console.log(`Reload Page is Called ===>${new Date().toLocaleDateString()}`);

            this.auctionData.is_closed = 1;
            if (this.auctionData.is_reserve && Number(this.bidders[0].price) < Number(this.auctionData.reserve_price)) {
              this.winnerAuction = true;
              this.getWinner();

              if (this.winnerAuction == true && this.userInfo.user.role_code == 'General' && this.bidders[0].userID == this.userInfo.user.id) {
                this.openCongratulationDialog()
              } else if (this.userInfo.user.role_code == 'General' && this.bidders[0].userID != this.userInfo.user.id) {
                this.winnerAuction = false;
                this.openItemEndedDialog()
              }


            }
          }
          this.onGetAuction();
        })
    )

    // To detect if any updated happend in this auction
    this.subscriptions.push(
      this.socket.getDataStream<string>(SocketEventType.RoomOrAuctionUpdated)
        .subscribe(message => {
          let data: SocketUpates = message.data;
          if (this._config.getAuthUserInfo()?.user?.role_code == 'General') {
            this.OpenConfirmRedirect(data);

          }
        })
    )

    this._SharedService.GetOnlineStatus().subscribe(status => {
      if (status && !this.OnlineStatus) {
        this.loading = true;
        this.onGetAuction();
      }
      this.OnlineStatus = status;
    })

  }
  reloadPage(event: string) {
    // const currentRoute = this._activatedRouter.snapshot.url.join('');
    // this.router.navigate(['rooms/auction/',this.auctionId], { queryParams: { reload: true } });


    this.loading = true;
    this.onGetAuction();
    this.priceNotVaild();

    this.getBalance();
    // this.onNewBidding();
    this.MediaConfig();
  }
  getBalance() {
    this.socket?.socket?.emit("getMyBlance");
    // this.socket?.socket?.on("getMyBlance", (data: any) => {
    //   this.current_balance = data.toFixed(2);
    // });
    this.subscriptions.push(
      this.socket.getDataStream<string>(SocketEventType.Get_My_Blance)
        .subscribe(message => {
          this.current_balance = message.data.toFixed(2);
          console.log("From Get_My_Blance: " + SocketEventType.Get_My_Blance);

        })
    )


  }
  onNewBidding(data: any) {
    // this.socket?.socket?.on(this.auctionId, (data: any) => {
    // this.bidders.filter()

    if (data.item.userID != this._config.getAuthUserInfo().user.id) {


      if (!data.item.is_anonymous) {
        this.msgToastr = `${data.item.username}
            ${this.translate.instant('Auction Item.hasBidHigherAt')}
            ${data.item.price}
            ${this.translate.instant('Auction Item.onTheAuction')}
            ${this.auctionData.name}`;
      } else {
        this.msgToastr = `
            ${this.translate.instant('Auction Item.someoneSubmittedHigherBid')}
            ${data.item.price}
            ${this.translate.instant('Auction Item.onTheAuction')}
            ${this.auctionData.name}`;
      }
      this._config.toastrService.clear();
      this._config.toastrService.success(this.msgToastr, '');
    }

    if (this.bidders.length == 5) {
      this.bidders.pop();
    }

    this.bidders = [...[data.item], ...this.bidders];

    if (!this.auctionData.end_at) {
      if (this.bidders.length == 1) {
        const secondsDiff = moment().diff(moment(data.item.createdAt), 'seconds');

        const duration = 30;
        const timeLeft = 30 - secondsDiff;
        const percent = this.timeLeft / 30 * 100;
        const second = 90 - secondsDiff;
        this.unsubscribeTimerAuctionNoEndTime()
        this.timerAuctionNoEndTime(duration, timeLeft, percent, second);
      } else {
        const secondsDiff = moment().diff(moment(data.item.createdAt), 'seconds');

        const duration = 30;
        const timeLeft = 30 - secondsDiff;
        const percent = 100;
        const second = 30 - secondsDiff;
        this.unsubscribeTimerAuctionNoEndTime()
        this.timerAuctionNoEndTime(duration, timeLeft, percent, second);

      }
    }



    this.number = Number(data.item.price);
    this.CustomPrice = Number(data.item.price);
    // debugger
    this.lastbid = data.item.userID == this.userInfo.user.id ? this.number : this.lastbid;
    this.winnerUserAuction = data.item.userID;
    //this.current_balance = Math.round( this.current_balance- this.number);

    if (data.date) {
      data.date = Math.floor(data.date / 1000);
      this.endDateTimer = moment.unix(data.date);
      this.auctionData.remaining_time = 59;
      this.timeExtended = true;


    }

    //this.current_balance = data.item.userID == this.userInfo.user.id ? Math.round(this.actual_current_balance - data.item.price) : this.current_balance;

    var media = new Audio('assets/sound/Notification.mp3');

    const playPromise = media.play();

    this.winnerAuction = data.item.userID == this.userInfo.user.id ? true : false;


    // })
  }

  priceNotVaild() {
    this.subscriptions.push(
      this.socket.getDataStream<string>(SocketEventType.Price_Not_Valid)
        .subscribe(message => {
          console.log("From Price_Not_Valid: " + SocketEventType.Price_Not_Valid);

          this._config.toastrService.clear();
          this._config.showToastr(this._config.translate.instant("Auction Item.Another bidder bid on this price"))
        })
    )
    // this.socket?.socket?.on('priceNotVaild', (data: any) => {
    // })
  }


  notEnoughFund() {
    this.subscriptions.push(
      this.socket.getDataStream<string>(SocketEventType.Not_Enough_Fund)
        .subscribe(message => {
          console.log("From Not_Enough_Fund: " + SocketEventType.Not_Enough_Fund);

          console.log("Hello 1111");
          const dialogRef = this.dialog.open(NotEnoughFundComponent, {
            width: '550px',
            panelClass: 'customDialogStyle'
          });
        })
    )
    // this.socket?.socket?.on('notEnoughFund', (data: any) => {
    //   console.log("Hello 1111");
    //   const dialogRef = this.dialog.open(NotEnoughFundComponent, {
    //     width: '550px',
    //     panelClass: 'customDialogStyle'
    //   });
    // })
  }
  onGetBidders() {
    this.socket?.socket?.emit("getBidders", { id: this.auctionId, type: "normal" });
    this.subscriptions.push(
      this.socket.getDataStream<string>(SocketEventType.Get_Bidders)
        .subscribe(message => {
          console.log("From Get_Bidders: " + SocketEventType.Get_Bidders);

          this.bidders = message.data;
          this.number = message.data.length ? Number(message.data[0].price) : this.number;
          this.LastBidder = message.data.length ? message.data[0] : null;
          this.CustomPrice = this.number;

          if (message.data.length) {
            this.winnerAuction = message.data[0].userID == this.userInfo.user.id ? true : false;
            this.checkWinner(false);
            // if (!this.auctionData.end_at) {



            // }

            if (message.data.length > 1) {



              const after30Seconds = moment(message.data[0].createdAt).add(30, 'seconds');
              if (!this.auctionData.end_at && moment().isBefore(after30Seconds)) {
                const secondsDiff = moment().diff(moment(message.data[0].createdAt), 'seconds');

                const duration = 30;
                const timeLeft = 30 - secondsDiff;
                const percent = timeLeft / 30 * 100;
                const second = 30 - timeLeft;
                this.unsubscribeTimerAuctionNoEndTime()
                this.timerAuctionNoEndTime(duration, timeLeft, percent, second);

                this.auctionStatus = 'ongoing';
              }

              if (!this.auctionData.end_at && moment().isAfter(after30Seconds)) {
                this.auctionStatus = 'end';
                this.OnReload('ongoing', false);
              }

            }
            if (message.data.length == 1) {
              const after90Seconds = moment(message.data[0].createdAt).add(90, 'seconds');
              if (!this.auctionData.end_at && moment().isBefore(after90Seconds)) {
                // this.unsubscribeTimerAuctionNoEndTime() //by_khaled
                this.auctionStatus = 'ongoing';
                const secondsDiff = moment().diff(moment(message.data[0].createdAt), 'seconds');
                console.log("secondsDiff from moment ==> ", secondsDiff);
                var timeLeft: any;
                var second: any;
                if (secondsDiff < 90 && secondsDiff > 60) {
                  timeLeft = 90 - secondsDiff;
                  second = timeLeft;

                }
                if (secondsDiff < 60 && secondsDiff > 30) {
                  timeLeft = 60 - secondsDiff;
                  second = timeLeft + 30;
                }

                if (secondsDiff < 30) {
                  timeLeft = 30 - secondsDiff;
                  second = timeLeft + 60;

                }







                const duration = 30;
                const percent = timeLeft / 30 * 100;

                this.unsubscribeTimerAuctionNoEndTime()
                this.timerAuctionNoEndTime(duration, timeLeft, percent, second);
              }

              if (!this.auctionData.end_at && moment().isAfter(after90Seconds)) {
                this.auctionStatus = 'end';
                this.OnReload('ongoing', false); // by_khaled

              }
            }

          } else {
            // this.winnerAuction = this.auctionData?.winner_id == this.userInfo.user.id ? true : false;
            if (!this.auctionData.end_at && moment().isAfter(moment().format(this.startDateTimer))) {
              this.duration = 90;
              this.timeLeft = this.duration;
              this.percent = 100;
              this.second = 90;
              this.auctionStatus = 'ongoing';
            }
          }

          this.winnerUserAuction = message.data.length ? message.data[0].userID : 0;
          const obj = message.data.find((item: any) => item.userID == this.userInfo.user.id);
          this.lastbid = obj ? Number(obj.price) : this.lastbid;
          this.getBidders = false;
          this.loading = false;
          //this.current_balance = obj ? Math.round(this.current_balance - obj.price) : this.current_balance;


        })
    )
    // this.socket?.socket?.on('getBidders', (data: any) => {
    //   this.bidders = data;
    //   this.number = data.length ? Number(data[0].price) : this.number;
    //   this.LastBidder = data.length ? data[0] : null;
    //   this.CustomPrice = this.number;

    //   if (data.length) {
    //     this.winnerAuction = data[0].userID == this.userInfo.user.id ? true : false;
    //     this.checkWinner(false);
    //     // if (!this.auctionData.end_at) {



    //     // }

    //     if (data.length > 1) {



    //       const after30Seconds = moment(data[0].createdAt).add(30, 'seconds');
    //       if (!this.auctionData.end_at && moment().isBefore(after30Seconds)) {
    //         const secondsDiff = moment().diff(moment(data[0].createdAt), 'seconds');

    //         const duration = 30;
    //         const timeLeft = 30 - secondsDiff;
    //         const percent = timeLeft / 30 * 100;
    //         const second = 30 - timeLeft;
    //         this.unsubscribeTimerAuctionNoEndTime()
    //         this.timerAuctionNoEndTime(duration, timeLeft, percent, second);

    //         this.auctionStatus = 'ongoing';
    //       }

    //       if (!this.auctionData.end_at && moment().isAfter(after30Seconds)) {
    //         this.auctionStatus = 'end';
    //         this.OnReload('ongoing', false);
    //       }

    //     }
    //     if (data.length == 1) {
    //       const after90Seconds = moment(data[0].createdAt).add(90, 'seconds');
    //       if (!this.auctionData.end_at && moment().isBefore(after90Seconds)) {
    //         // this.unsubscribeTimerAuctionNoEndTime() //by_khaled
    //         this.auctionStatus = 'ongoing';
    //         const secondsDiff = moment().diff(moment(data[0].createdAt), 'seconds');
    //         console.log("secondsDiff from moment ==> ", secondsDiff);
    //         var timeLeft: any;
    //         var second: any;
    //         if (secondsDiff < 90 && secondsDiff > 60) {
    //           timeLeft = 90 - secondsDiff;
    //           second = timeLeft;

    //         }
    //         if (secondsDiff < 60 && secondsDiff > 30) {
    //           timeLeft = 60 - secondsDiff;
    //           second = timeLeft + 30;
    //         }

    //         if (secondsDiff < 30) {
    //           timeLeft = 30 - secondsDiff;
    //           second = timeLeft + 60;

    //         }







    //         const duration = 30;
    //         const percent = timeLeft / 30 * 100;

    //         this.unsubscribeTimerAuctionNoEndTime()
    //         this.timerAuctionNoEndTime(duration, timeLeft, percent, second);
    //       }

    //       if (!this.auctionData.end_at && moment().isAfter(after90Seconds)) {
    //         this.auctionStatus = 'end';
    //         this.OnReload('ongoing', false); // by_khaled

    //       }
    //     }

    //   } else {
    //     // this.winnerAuction = this.auctionData?.winner_id == this.userInfo.user.id ? true : false;
    //     if (!this.auctionData.end_at && moment().isAfter(moment().format(this.startDateTimer))) {
    //       this.duration = 90;
    //       this.timeLeft = this.duration;
    //       this.percent = 100;
    //       this.second = 90;
    //       this.auctionStatus = 'ongoing';
    //     }
    //   }

    //   this.winnerUserAuction = data.length ? data[0].userID : 0;
    //   const obj = data.find((item: any) => item.userID == this.userInfo.user.id);
    //   this.lastbid = obj ? Number(obj.price) : this.lastbid;
    //   this.getBidders = false;
    //   this.loading = false;
    //   //this.current_balance = obj ? Math.round(this.current_balance - obj.price) : this.current_balance;

    // });

  }

  onGetAuction() {
    this._auctionApi.getOneAuction(this.auctionId).subscribe({
      next: (data) => {

        console.log("this Object Here", data);
        this.auctionData = data.data;

        if (this.auctionData.is_multi_auction || this.auctionData?.room?.is_multi_auction) {
          if (this._config.getAuthUserInfo()?.user?.role_code == "General") {
            this._config.goTo("/mulit-auction/" + this.auctionData?.room?.id);
          } else {
            this._config.goTo("/rooms/Multi/detailes/" + this.auctionData?.room?.id);
          }
        }
        this.btns = data?.data?.btns.filter((item: any) => item?.price != null);
        this.number = Math.trunc(this.auctionData.minimum_price);
        this.CustomPrice = this.number;
        this.winnerAuction = this.auctionData?.winner_id?.id == this.userInfo?.user.id ? true : false;
        this.timeExtended = this.auctionData?.minutes;
        //this.current_balance = Math.trunc(this.auctionData.current_balance);
        this.actual_current_balance = Math.trunc(this.auctionData.current_balance);
        this.detailsItem = data.data.details;
        this.slider = data.data.files.filter((file: any) => file.isMain == 0);
        this.MediaConfig()
        this.filterDetails();
        this.getRemaining();
        this.loading = false;
        this.startDateTimer = moment.utc(this.auctionData.start_date).local().format();
        // debugger
        this.endDateTimer = moment.utc(moment(this.startDateTimer).format('YYYY/MM/DD') + ' ' + moment.utc(this.auctionData.end_date).format('H:mm:ss')).local().format();

        // debugger
        if (moment().isBefore(moment().format(this.startDateTimer))) {
          this.auctionStatus = 'upcoming';
        } else if ((moment().isAfter(moment().format(this.startDateTimer)) && moment().isBefore(moment().format(this.endDateTimer))) && this.auctionData.end_at) {
          this.auctionStatus = 'ongoing';
        } else if (moment().isAfter(moment().format(this.startDateTimer)) && !this.auctionData.end_at && !this.auctionData.is_closed) {
          this.auctionStatus = 'ongoing';
        }


        if (this.auctionStatus == 'ongoing') {
          this.getRemainingSocket();
        }

        this.onGetSeconds();
        this.onGetBidders();

      }, error: (err) => {
        if (err.errors[0].field == "itemNotFound") {
          this._config._router.navigate(["/no-permission"])
        }
        this.loading = false;
      }
    })
  }
  getRemainingSocket() {
    this.subscriptions.push(
      this.socket.getDataStream<string>("getRemaining" + this.auctionId)
        .subscribe(message => {


          this.auctionData.remaining_time = message.data.response;

          if (this.auctionData?.is_reserve && !this.auctionData?.is_closed && message.data.response <= 300) {
            this.showIncreasePrice = true;
          }


          if (message.data.response == 0) {
            this.OnReload('ongoing', true);
          }

        })
    )
  }
  onAuctionEnd(price: any) {

    if (this.userInfo.user.id == this.winnerUserAuction) {
      this._auctionApi.auctionEnd({ amount: price }).subscribe({
        next: (data) => {


        }, error: (err) => {

        }
      });
    }

  }
  onGetSeconds() {
    this._timer.GetSeconds().subscribe((res: any) => {
      this.SECONDS = res.seconds;
      this.minutes = res.minutes;
      if (this.minutes == 0 && this.SECONDS == 0) {

        this.onAuctionEnd(this.number);
        window.location.reload();
      }
    })
  }
  onAddPrice(price: number) {

    const dataSend = {
      auctionID: this.auctionData.id,
      price: Math.round(this.number + price),
      auth: this._config.getAuthUserInfo().user
    }

    this.socket?.socket?.emit("newPrice", dataSend);


  }

  onAddCustomPrice(type: string, price: number) {


    const number = type == 'plus' ? Math.round(Number(this.CustomPrice) + Number(price)) : Math.round(Number(this.CustomPrice) - Number(price));
    console.log(price, number);
    if (type == 'minus') {
      this.minus = number == this.number ? true : false;
    }
    this.CustomPrice = number;
  }

  onSendCustomPrice() {

    this.onAddPrice(Math.round(this.CustomPrice - this.number));
  }


  filterDetails() {
    // this.detailsItem = this.detailsItem.filter((el) => {
    //   return el.lang == this._config.lang;
    // });
  }



  scroll(el: HTMLElement) {
    el.scrollIntoView();
  }

  onJoinAuction() {

    if (this.current_balance < this.auctionData.minimum_price) {

      const dialogRef = this.dialog.open(NotEnoughFundComponent, {
        width: '550px',
        data: { current_balance: this.current_balance, price: this.auctionData.minimum_price, type: 'join' },
        panelClass: 'customDialogStyle'
      });
    } else {
      const dialogRef = this.dialog.open(JoinAuctionComponent, {
        width: '550px',
        data: this.auctionData,
        panelClass: 'customDialogStyle'
      });

      dialogRef.afterClosed().subscribe((res) => {
        if (res == 'success') {
          this.onGetAuction();
          this.getBalance();
          this.onGetBidders();
        }
      });
    }


  }



  onWithdrawAuction() {
    const dialogRef = this.dialog.open(WithdrawComponent, {
      width: '550px',
      data: this.auctionData,
      panelClass: 'customDialogStyle'
    });

    dialogRef.afterClosed().subscribe((res) => {
      if (res == 'success') {
        this.onGetAuction();
      }
    });
  }
  youtubeURL(url: any) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }




  MediaConfig() {

    /** Basic Gallery Example */

    // Creat gallery items
    this.MediaList = this.slider.map(item => new ImageItem({ src: item.path, thumb: item.path }));


    /** Lightbox Example */

    // Get a lightbox gallery ref
    const lightboxRef = this.gallery.ref('lightbox');

    // Add custom gallery config to the lightbox (optional)
    lightboxRef.setConfig({
      imageSize: ImageSize.Contain,
      thumbPosition: ThumbnailsPosition.Bottom,
      autoHeight: true
    });

    // Load items into the lightbox gallery ref
    lightboxRef.load(this.MediaList);
  }


  when30SecondsEnded(event: any) {

    if (this.TotalCounts > 0 && event) {
      this.currentCount = 30 + Math.random();
      this.TotalCounts = this.TotalCounts - 30;
    } else if (this.TotalCounts == 0) {
      location.reload();
    }

  }

  OnReload(status: string, showDialog: boolean = false) {
    // debugger
    console.log(`OnReload Function is Called at ===>${new Date().toLocaleDateString()}`);

    if (status == 'upcoming') {
      this.auctionStatus = 'ongoing';
      this.auctionData.remaining_time = moment(this.auctionData?.end_date).unix() - moment(this.auctionData?.start_date).unix();

      this.getRemainingSocket();


    } else {
      this.auctionStatus = 'end';
      this.auctionData.last_bidding = this.bidders[0]?.price;
      this.checkWinner(showDialog);
      clearInterval(this.intervalRemaining);
    }
  }



  checkWinner(showDialog: boolean) {
    console.log(`Check Winner Function is Called at ===>${new Date().toLocaleDateString()}`);
   
    if (this.auctionStatus == 'end') {
      this.auctionData.is_closed = 1;

      console.log(this.winnerAuction);
      // debugger
      // if (this.winnerAuction && this.bidders.length && !this.auctionData.is_reserve) {
      //   this.winnerAuction = true;
      //   this.getWinner();
      // }
      if (this.winnerAuction && this.bidders[0]?.userID == this.userInfo.user.id && !this.auctionData.is_reserve) {
        this.winnerAuction = true;
        this.getWinner();
      }



      if (this.winnerAuction && this.bidders[0]?.userID == this.userInfo.user.id && this.auctionData.is_reserve && Number(this.bidders[0]?.price) >= Number(this.auctionData.reserve_price)) {
        this.winnerAuction = true;
      
        
      }


      if (this.auctionData.is_reserve && (Number(this.bidders[0]?.price) < Number(this.auctionData.reserve_price) || !this.bidders.length)) {
        this.winnerAuction = false;
      }

      if (this.auctionData.is_reserve && Number(this.bidders[0]?.price) >= Number(this.auctionData.reserve_price) && (this.auctionData.is_owner || this.userInfo.user.role_code == 'Admin' || this.userInfo.user.role_code == 'Auctioneer' || this.userInfo.user.role_code == 'Master')) {
        this.winnerAuction = true;
        this.getWinner();
       
      }

      if (!this.auctionData.is_reserve && (this.auctionData.is_owner || this.userInfo.user.role_code == 'Admin' || this.userInfo.user.role_code == 'Auctioneer' || this.userInfo.user.role_code == 'Master')) {
        this.winnerAuction = true;
        this.getWinner();
        console.log(this.auctionData)
      }
      if (!this.auctionData.end_at && this.bidders.length && (this.auctionData.is_owner || this.userInfo.user.role_code == 'Admin' || this.userInfo.user.role_code == 'Auctioneer' || this.userInfo.user.role_code == 'Master')) {
        this.winnerAuction = true;
        this.getWinner();
      }




      if (this.winnerAuction == true && this.userInfo.user.role_code == 'General' && showDialog && this.auctionData.is_joined) {
        this.openCongratulationDialog()
      } else if (this.winnerAuction == false && this.userInfo.user.role_code == 'General' && showDialog) {
        this.openItemEndedDialog()
      }

    }

  }

  openCongratulationDialog() {
    const dialogRef = this.dialog.open(AuctionWinnerPopUpComponent, {
      width: '550px',
      data: this.auctionData,
      panelClass: 'customDialogStyle'
    });

    dialogRef.afterClosed().subscribe((res) => {

    })
  }

  openItemEndedDialog() {
    const dialogRef = this.dialog.open(AuctionEndedPopUpComponent, {
      width: '550px',
      // data: this.auctionData,
      panelClass: 'customDialogStyle'
    });

    dialogRef.afterClosed().subscribe((res) => {

    })
  }

  getWinner() {
    if (this.auctionData?.is_owner) {
      return this.auctionData.winner_id = {
        firstname: this.bidders[0]?.firstname,
        lastname: this.bidders[0]?.lastname,
        image: ''
      };
    } else {
      return this.auctionData.winner = {
        firstname: this.bidders[0]?.firstname,
        lastname: this.bidders[0]?.lastname,
        image: ''
      };
    }

  }

  OpenConfirmRedirect(actionType: SocketUpates) {
    let title, lable, action: string = ''

    if (actionType.auctionId === this.auctionId && !actionType.isChangeOnRoom && !actionType.isMulti) {
      //when item is updated 
      if (actionType.typeChanges == socketActions.UPDATED) {
        title = "multiAuction.Update your item information"
        lable = "multiAuction.this item has been updated form administrator press Confirm to continue"
        action = 'reload';

      }
      //when deleting or unpublishing 
      else if (actionType.typeChanges == socketActions.DELETED || actionType.typeChanges == socketActions.UN_PUBLISHED) {
        title = "multiAuction.Hard Redirect"
        lable = "multiAuction.this item has been Deleted."
        action = 'go_main_room';
      }
    }

    //when import this item 
    if (actionType.auctionId === this.auctionId &&
      actionType.isChangeOnRoom &&
      !actionType.isMulti &&
      actionType.typeChanges == socketActions.IMPORTED) {
      title = "multiAuction.Hard Redirect"
      lable = "multiAuction.this item has been imported to another auction (items in queue)."
      action = 'go_home';
    }

    // when room Deleted or unpublished
    if (actionType.isChangeOnRoom && actionType.roomId == this.auctionData.room?.id && !actionType.isMulti) {
      if (actionType.typeChanges == socketActions.DELETED || actionType.typeChanges == socketActions.UN_PUBLISHED) {
        title = "multiAuction.Hard Redirect"
        lable = "multiAuction.this auction has been Deleted."
        action = 'go_home';
      }
    }
    if (action) {
      this.dialog.closeAll();
      const dialogRef = this.dialog.open(HardRedirectComponent, {
        width: '550px',
        data: { title, lable },
        panelClass: 'customDialogStyle',
        disableClose: true
      });

      dialogRef.afterClosed().subscribe((res: any) => {
        if (res)
          switch (action) {
            case 'reload':
              this.onGetAuction();
              break;
            case 'go_main_room':
              if (this._config.getAuthUserInfo().user?.role_code == "General") {
                this._config.goTo("/MainAuction/" + this.auctionData?.room?.id)
              } else {
                this._config.goTo("/rooms/detailes/" + this.auctionData?.room?.id)
              }
              break;
            case 'go_home':
              if (this._config.getAuthUserInfo().user?.role_code == "General") {
                this._config.goTo("/")
              } else {
                this._config.goTo("/rooms")
              }
              break;
          }

      })
    }

  }


  ngOnDestroy(): void {
    clearInterval(this.intervalRemaining)
    this.subscriptions.forEach(sub => sub.unsubscribe());

  }
}



